import PropTypes from 'prop-types';
import ThemeStatePropTypes from '../../State/Store/Theme/Theme.props';

const ConfirmMobileNumberModalPropTypes = {
  /**
   * The JSS classes to use
   */
  classes: ThemeStatePropTypes.classes.isRequired,

  /**
   * States if modal is open
   */
  open: PropTypes.bool,

  /**
   * Callback when No is clicked
   */
  onNo: PropTypes.func,

  /**
   * Callback when Yes is clicked
   */
  onYes: PropTypes.func,
};

export default ConfirmMobileNumberModalPropTypes;
